import React, {useEffect, useMemo, useState} from "react";
import ReactTable from "react-table-v6"
import { IconButton } from "@material-ui/core";
import { AddCircle, CheckCircle, ModeEdit, Settings } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

import 'react-table-v6/react-table.css'
import { Autocomplete, TextField, Tooltip } from "@mui/material";
import { getFeatureTypes } from "../../services/DimensionsServices";
import { getSpaceFeatures, updateFeature } from "../../services/MetadataService";

const FeatureList = (props) => {
    let [features, setFeatures] = useState(props.features)

    const [editMode, setEditMode] = useState(false)
    const [featureTypes, setFeatureTypes] = useState()
    const [error, setError] = useState()
    const [editFeature, setEditFeature] = useState()

    let history = useHistory();

    const featureAddPath = useMemo(() => {
        const params = new URLSearchParams();
        if (props.siteId) {
            params.set("site_id", props.siteId);
        }
        if (props.buildingId) {
            params.set("building_id", props.buildingId);
        }
        if (props.spaceId) {
            params.set("space_id", props.spaceId);
        }
        const search = params.toString()
        return { pathname: "/features/add", search };
    }, [props.siteId, props.buildingId, props.spaceId ]);

    useEffect(() => {
        getFeatureTypes().then(response => {
            setFeatureTypes(response)
        })
    },[])

    const submitChange = (feature) => {
        updateFeature(feature).then(() => {
            getSpaceFeatures(feature.space_id).then(response => {
                setEditMode(false)
                setEditFeature(null)
                setFeatures(response);
            })
        }).catch(err => {
            console.log(err);
            setError("Did not successfully update feature")
        })
    }

    const columns = [
        {
            Header: 'Name',
            accessor: 'name',
            style: {paddingTop: 15},
            Cell: p => {
                return editMode && editFeature.id === p.original.id ?
                <TextField defaultValue={p.value} variant="outlined" size="small"
                    onBlur={(e) => {
                        let feature =Object.assign({}, editFeature)
                        feature.name = e.target.value;
                        setEditFeature(feature)
                    }}/> : p.value
            }
        },
        {
            Header: 'Type',
            accessor: 'feature_type',
            style: {paddingTop: 15},
            Cell: p => {
                let selectedType = featureTypes && featureTypes.find(t => t.feature_type === p.value);

                if (editMode && editFeature.id === p.original.id) {
                    return <Autocomplete
                        disablePortal
                        id="feature-types"
                        width={250}
                        options={featureTypes || []}
                        getOptionLabel={option => option.name}
                        style={{ width: "250px" }}
                        value={selectedType}
                        isOptionEqualToValue={(option, value) => option.feature_type === value.feature_type}
                        renderInput={(params) => <TextField {...params} variant="outlined" size="small" />}
                        onChange={(event, newValue) => {
                            let feature =Object.assign({}, editFeature)
                            feature.feature_type = newValue.feature_type;
                            setEditFeature(feature)
                        }}
                    />
                } else {
                    return selectedType && selectedType.name;
                }


            },
        },
        {
            Header: '',
            accessor: 'id',
            width: 100,
            Cell: p => {
                return <div className="row-buttons">
                    {
                        editMode ?
                        <Tooltip title="Edit">
                            <IconButton
                                variant="contained"
                                color="primary"
                                aria-label={"Edit Feature" }
                                size={"small"}
                                onClick={() => {

                                    submitChange(editFeature)
                                }}>
                                    <CheckCircle />
                            </IconButton>
                        </Tooltip> : null
                    }
                    <Tooltip title="Edit">
                        <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={"Edit Feature" }
                            size={"small"}
                            onClick={() => {
                                setEditFeature(!editMode ? p.original : null)
                                setEditMode(!editMode)
                            }}>
                                <ModeEdit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Configure">
                        <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={"View feature configuration" }
                            size={"small"}
                            onClick={() => {
                                history.push("/variables/feature/" + p.value)
                            }}>
                                <Settings />
                        </IconButton>
                    </Tooltip>
                </div>
            },
        },
    ]

        return (
            <div className="feature-list">
                <div className="space-add-mode">
                    {
                        props.features && props.features.length ?
                        <Tooltip title="Add Features">
                            <IconButton
                                        variant="contained"
                                        color="primary"
                                        aria-label={"Add features" }

                                        onClick={() => {
                                            history.push(featureAddPath)
                                    }}>
                                        <AddCircle style={{fill: "#00b088", background: "white", transform: "scale(1.0)"}}/>
                            </IconButton>
                        </Tooltip> : null }
                </div>
                <div className="section-header">Features </div>
                {
                    props.features && props.features.length ?
                        <div className="point-list-table">
                            <ReactTable key={(props.features && props.features.length) || 0}
                                data={props.features || []}
                                columns={columns}
                                minRows={0}
                                defaultPageSize={10}
                                showPagination={props.features && props.features.length > 10}
                            />
                        </div>
                        :
                        <div className="bulk_add_prompt">
                        <IconButton
                                    variant="contained"
                                    color="primary"
                                    aria-label={"Add features" }

                                    onClick={() => {
                                        history.push(featureAddPath)
                                }}>
                                <AddCircle style={{fill: "#00b088", background: "white"}}/>
                        </IconButton>
                        There are currently no features configured.  Add some now!
                    </div>
                }
            </div>



        )
}

export default FeatureList;
